import React, { useEffect, useState } from "react";
import Boardcard from "../../Components/Boardcard/Boardcard";
import ButtonPagenate from "../../Components/ButtonPagenate/ButtonPagenate";
import Navbar from "../../Components/Navbar/navbar";
import Topbarsub from "../../Components/Topbar/Topbarsub";
import "./employee.css";
// import EmployeeList from './employeeList'
import { GrEdit } from "react-icons/gr";
import { AiFillDelete } from "react-icons/ai";
import { useCookies } from "react-cookie";
import DepartmentsFilter, {
  CountriesFilter,
} from "../ListFunction/listfunction";

const Employee = ({ page, addnewoverlay, empselect }) => {
  let indexCount = 0;
  const [cookies] = useCookies(["Token"]);
  const [searchcriteria, setSearchcriteria] = useState("");
  const [employee, setEmployee] = useState(empselect.allStaffs);
  const [nameSearch, setNameSearch] = useState("");
  const API = "https://";

  const [pageNumber, setPageNumber] = useState(0);
  //   const [loading, setLoading] = useState(true)
  //   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 8; //Number of items to be displayed per page
  const pageCount = Math.ceil(employee.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;
  //   const API = 'https://admin.sabrecwa.com/backend'

  const handleSearchCriteria = (incoming) => {
    setSearchcriteria(incoming);
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddNewEmp = () => {};

  const filterSearch = (incoming) => {
    setNameSearch(incoming.toString());
  };

  var EmployeeLists = employee.filter((filteredItem) => {
    if (searchcriteria === "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria === "" && nameSearch !== "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch !== "") {
      if (searchcriteria === "Fullname") {
        if (
          filteredItem.firstname
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Designation") {
        if (
          filteredItem.designation
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Department") {
        if (
          filteredItem.department
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Country") {
        if (
          filteredItem.country.toLowerCase().includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Phone No.") {
        if (
          filteredItem.phone.toLowerCase().includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else {
        return filteredItem;
      }
    }
  });

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  const handleEdit = (incoming) => {
    addnewoverlay(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleaddOverlay = (incoming) => {
    addnewoverlay(incoming);
    // console.log(incoming)
  };

  // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  const handleDelete = async (props) => {
    // setConfirmload(true)
    try {
      var config = {
        method: "PUT",
        url: `${API}/changeEmpactive/${props}`,
        data: {},
        headers: {
          Authorization: "Bearer " + cookies.Token,
        },
      };

      //   await axios(config).then((response) => {
      //   // console.log(response.data.data);
      //   if(response.data.success === true){
      //     // do something
      //   }else{
      //     // do something
      //   }});
    } catch (e) {
      if (e.message.includes("401")) {
        // catch error
      } else {
        // catch error
      }
    }
  };

  useEffect(() => {
    handleWidth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [widthval, setWidthval] = useState({
    pie1: 0,
    pie2: 0,
    pie3: 0,
  });

  let employeeLength = empselect.allStaffs.length;
  let employeeMale = empselect.allStaffs.filter(
    (employeeObj) => employeeObj.gender === "Male"
  ).length;
  let employeeFemale = empselect.allStaffs.filter(
    (employeeObj) => employeeObj.gender === "Female"
  ).length;

  const handleWidth = () => {
    setWidthval({
      pie1: employeeLength,
      pie2: employeeMale,
      pie3: employeeFemale,
    });
  };

  return (
    <div className="employee-container">
      <Navbar tabtext="Employees Overview" currentab="others" />
      <Topbarsub
        serchCriteria={handleSearchCriteria}
        newEmployee={handleAddNewEmp}
        currrenTab={page}
        searchword={filterSearch}
        addoverlay={handleaddOverlay}
      />
      <div className="tretapp-card-container">
        <Boardcard
          val={widthval.pie1}
          name="Total Employee"
          maxV={50}
          minV={0}
        />
        <Boardcard
          val={widthval.pie2}
          name="Male Employee"
          maxV={widthval.pie1}
          minV={0}
        />
        <Boardcard
          val={widthval.pie3}
          name="Female Employee"
          maxV={widthval.pie1}
          minV={0}
        />
      </div>

      <div className="tretapp-list-submitted">
        <div className="tapp-list-title-container">
          <span id="tapp-list-title">Employee Lists</span>
        </div>
        <div className="comp-list-table-containerr">
          <table>
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Fullname</th>
                <th scope="col">PhoneNo</th>
                <th scope="col">Email</th>
                <th scope="col">Gender</th>
                <th scope="col">Designation</th>
                <th scope="col">Department</th>
                <th scope="col">Country</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {EmployeeLists.reverse()
                .slice(pagesVisited, pagesVisited + itemsPerpage)
                .map((items) => (
                  <tr>
                    <td data-label="EmpID">{++indexCount}</td>
                    <td data-label="Fullname">
                      {items.last_name + " " + items.first_name}
                    </td>
                    <td data-label="PhoneNo">{items.phone}</td>
                    <td data-label="Email">{items.email}</td>
                    <td data-label="Gender">{items.gender}</td>
                    <td data-label="Designation">{items.designation}</td>
                    <td data-label="Departmnent">
                      {DepartmentsFilter(empselect, items.department_id)}
                    </td>
                    <td data-label="Country">
                      {CountriesFilter(empselect, items.country_id)}
                    </td>
                    <td data-label="Action">
                      <GrEdit
                        onClick={() =>
                          handleEdit({ tag: "newemployee", ID: items.ID })
                        }
                        id="butn-action"
                      />
                      <AiFillDelete
                        onClick={() => handleDelete(items.ID)}
                        id="butn-action"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <div className="papp-table-pgnate-contain">
            <button
              id="addbitn"
              onClick={() => handleaddOverlay({ tag: "newemployee" })}
            >
              Add
            </button>
            <ButtonPagenate
              updatedPageNum={newPagenum}
              pageCount={pageCount}
              pageNumber={pageNumber}
              previousLabel="Prev"
              nextLabel="Next"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;
